import React from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';
import { formatText } from 'app/shared/util/method-util';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DevicesListModal = (props) => {
  const {
    className,
    modal,
    setModal,
    coverDetails
  } = props;

  const toggle = () => setModal(!modal);
  return (
    <div>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalBody>
          <div className="devicesListModalTitle" dangerouslySetInnerHTML={{ __html: formatText(coverDetails.title) }}/>
          <div className="coverDetailsList" dangerouslySetInnerHTML={{ __html: formatText(coverDetails.list) }}></div>
          {/* <ul className="fa-ul" style={{ textAlign: "left" }}>
                        {devicesList.map((d, i) => {
                            return (
                                <li key={i}><span className="fa-li"><img alt="cover" style={{ width: "10px" }} src={'/content/images/Icon material-check.svg'} /></span>{d}</li>
                            )
                        })}
                    </ul> */}
          <Button className="devicesListModalBtn" onClick={toggle}>
            Compris
            {'  '}
            <FontAwesomeIcon icon="arrow-right" />
          </Button>

        </ModalBody>
      </Modal>
    </div>
  );
}

export default DevicesListModal;
